import { render, staticRenderFns } from "./HostingEmail.vue?vue&type=template&id=46724675&"
import script from "./HostingEmail.vue?vue&type=script&lang=js&"
export * from "./HostingEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports